export default {
  fields: {
    price: 'Pris',
    tax: 'Moms',
    visible_to: 'Synlig for',
  },
  buttons: {
    add_price: '+ Tilføj pris',
  },
};
